/* eslint-disable import/order */
// redux ломается если что-то импортировано не так как он хочет
import React from 'react';
// при переезде на Vite стала падать ошибка https://github.com/TanStack/table/issues/3297, фикснулось этой библиотекой
import 'regenerator-runtime/runtime.js';
import '@vlabs/uikit/assets/css/uikit.css';
import { i18nReady } from '@vlapps/point/src/app/translations/i18n';

import { setRoutes } from '@vlabs/shared/navigation/routes';
import { registerErrorHandlers } from '@vlabs/shared/utils/error-handler';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import { store } from '@vlapps/point/src/app/store';
import '@vlapps/point/src/api/index';

import 'react-toastify/dist/ReactToastify.css';
import { initApp } from '@vlapps/point/src/app/store/appSlice';

import App from './app/PointApp';
import { routes } from './app/routes';

import '@vlapps/point/src/app/styles/index.sass';
import '@vlapps/point/src/app/styles/toasts.sass';
import '@vlapps/point/src/app/styles/variables.sass';

// async function enableMocking(): Promise<ServiceWorkerRegistration | undefined> {
//   if (import.meta.env.DEV || import.meta.env.MODE === 'staging') {
//     const { mockServiceWorker, mockedPaths } = await import('./mockServiceWorker');

//     return mockServiceWorker.start({
//       onUnhandledRequest(request, print) {
//         if (!mockedPaths.find((route) => request.url.includes(route))) {
//           return;
//         }
//         print.warning();
//       },
//     });
//   }

//   return undefined;
// }

const history = createBrowserHistory();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

setRoutes(routes);
registerErrorHandlers();

// enableMocking().then(() => {
store.dispatch(initApp);

// Ждём загрузки переводов (динамический import локалей по build-флагам __LOCALE_*__) перед первым рендером.
void i18nReady.then(() => {
  root.render(
    <React.StrictMode>
      <Router history={history}>
        <ReduxProvider store={store}>
          <App />
          <ToastContainer
            hideProgressBar
            position={toast.POSITION.TOP_LEFT}
          />
        </ReduxProvider>
      </Router>
    </React.StrictMode>,
  );
});
// });

// expose store when run in Cypress
// FIXME: use only in test environment
if (window.Cypress) {
  window.cprs = {
    store,
    history,
  };
}
